/**
 * Generated runtime TestId mirror for frontend/src/pages/FunctionGroupRequestWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FunctionGroupRequestWizardTestIds = {
  btnCancel: "btn-cancel",
  btnCollapseAllFgs: "btn-collapse-all-fgs",
  btnCollapseAllReview: "btn-collapse-all-review",
  btnExpandAllFgs: "btn-expand-all-fgs",
  btnExpandAllReview: "btn-expand-all-review",
  btnNextStep: "btn-next-step",
  btnPreviousStep: "btn-previous-step",
  btnSelectMyself: "btn-select-myself",
  btnSelectSomeoneElse: "btn-select-someone-else",
  btnSubmitRequest: "btn-submit-request",
  cardTitleReviewAndSubmit: "card-title-review-and-submit",
  cardTitleSelectFunctionGroups: "card-title-select-function-groups",
  cardTitleWhoNeedsAccess: "card-title-who-needs-access",
  fgAssociationEditor: "fg-association-editor",
  fgRequestStepContainer: "fg-request-step-container",
  functionGroupRequestWizardPage: "function-group-request-wizard-page",
  reviewFgItem: "review-fg-item",
  btnToggleFg: (item_functionGroup_id: string) => `btn-toggle-fg-${item_functionGroup_id}`,
  btnToggleFgPrefix: () => "btn-toggle-fg-" as TestIdPrefix,
  btnToggleReviewFg: (item_functionGroup_id: string) => `btn-toggle-review-fg-${item_functionGroup_id}`,
  btnToggleReviewFgPrefix: () => "btn-toggle-review-fg-" as TestIdPrefix,
  expirationDate: (item_functionGroup_id: string) => `expiration-date-${item_functionGroup_id}`,
  expirationDatePrefix: () => "expiration-date-" as TestIdPrefix,
  holdingStatus: (item_functionGroup_id: string) => `holding-status-${item_functionGroup_id}`,
  holdingStatusPrefix: () => "holding-status-" as TestIdPrefix,
  wizardApLink: (ap_accessProfile_id: string) => `wizard-ap-link-${ap_accessProfile_id}`,
  wizardApLinkPrefix: () => "wizard-ap-link-" as TestIdPrefix,
  wizardFgGrantsSummary: (item_functionGroup_id: string) => `wizard-fg-grants-summary-${item_functionGroup_id}`,
  wizardFgGrantsSummaryPrefix: () => "wizard-fg-grants-summary-" as TestIdPrefix,
  wizardFgLinkedAp: (fgId: string) => `wizard-fg-linked-ap-${fgId}`,
  wizardFgLinkedApPrefix: () => "wizard-fg-linked-ap-" as TestIdPrefix,
  wizardFgLinkedApEmpty: (fgId: string) => `wizard-fg-linked-ap-empty-${fgId}`,
  wizardFgLinkedApEmptyPrefix: () => "wizard-fg-linked-ap-empty-" as TestIdPrefix,
  wizardFgLinkedApNotAvailable: (fgId: string) => `wizard-fg-linked-ap-not-available-${fgId}`,
  wizardFgLinkedApNotAvailablePrefix: () => "wizard-fg-linked-ap-not-available-" as TestIdPrefix
} as const;
